import Choices from 'choices.js'

window.addEventListener('load', () => {

  const selects = document.querySelectorAll(`[data-item="select"]`)
  if (selects.length > 0) {
    selects.forEach((select) => {
      const choices = new Choices(select, {
        allowHTML: true,
      })
    })
  }
})
